


























































































































import { Component, Vue } from 'vue-property-decorator'
import ProConfig from '@/config/config'
import FuncUtils from '@/common/utils/FuncUtils'
import JavaHttp from '@/common/network/JavaHttp'
import { Base64 } from 'js-base64'
import { UserModule } from '@/store/modules/user'
import DlgInfo from '@/common/entity/DlgInfo'
import FormChangePassword from '@/views/login/form/form-change-password.vue'
import FormForgetPassword from '@/views/login/form/form-forget-password.vue'
import BindAccout from '@/views/login/form/bindAccout.vue'
import CookiesUtils from '@/common/utils/CookiesUtils'
import ValidateUtils from '@/common/utils/ValidateUtils'
import { sm4Encode } from '@/utils/sm4util'

@Component({
  name: 'Login',
  components: {
    FormChangePassword,
    FormForgetPassword,
    BindAccout
  }
})
export default class Login extends Vue {
  public dlgInfo: DlgInfo = new DlgInfo()

  public menuTabs = ['手机号登录', '企业微信登录']
  public codeLoading = true // 二维码加载
  public currentTab = 0
  public isBind = false // 企微是否绑定账号
  public formRules = {
    phone: [
      { required: true, message: '请输入手机号码' },
      {
        validator: (rule: any, value: any, callback: Function) => {
          const ret = ValidateUtils.isMobilePhone(value)
          if (!ret.result) {
            if (value == 'admin') {
              callback()
            } else {
              callback(new Error(ret.hintMsg))
            }
          } else {
            callback()
          }
        }
      }
    ],
    password: [{ required: true, message: '请输入密码' }],
    code: [{ required: true, message: '请输入验证码' }]
  }
  public formData: any = {
    phone: '',
    password: '',
    code: ''
  }
  public btnLoading = false
  public uiLock = false
  public title = '泛渠道平台管理系统'
  public version = ProConfig.getVersion()
  public redirect = ''

  public btnContent = '获取验证码'
  public getCodeStatus = false
  public user: any = {}
  public wechatUrl = ProConfig.getWechatBaseApi() // 跳转企微登录地址
  public bindParmas = {
    username: '',
    code: '',
    wxEnterpriseUserId: '',
    wxEnterpriseUserName: ''
  }
  mounted() {
    this.$watermark.set('')
    const code = this.$route.query.code
    if (code) {
      const url = '/public/auth/common/wxLogin'
      const params = { code }
      this.getTimeDiff()
      JavaHttp.postDataCallback(url, params, (ret: boolean, data: any) => {
        console.log(data)
        if (data.code === 0) {
          const info = Base64.decode(data.data.token).split(':')
          this.user = {
            id: info[0],
            account: this.formData.phone,
            token: data.data.token
          }
          UserModule.saveUserInfo(this.user)
          this.getUserInfo(this.user.token)
        } else if (data.code === 404) {
          if (data.detailMessage) {
            const jsonData =
              typeof data.detailMessage === 'string'
                ? JSON.parse(data.detailMessage)
                : data.detailMessage
            this.bindParmas.wxEnterpriseUserId = jsonData.wxEnterpriseUserId
            this.bindParmas.wxEnterpriseUserName = jsonData.wxEnterpriseUserName
            this.showBindDlg()
          }
        } else {
          FuncUtils.hitMessageError(data.msg)
        }
      })
    }
  }
  // 切换登录方式
  changeMenuTab(index: number) {
    if (index === 1) {
      window.location.href = this.wechatUrl
      return
    }
    this.currentTab = index
  }

  resetForm() {
    const form: any = this.$refs.formData
    form.resetFields()
  }
  // 登录
  submitForm() {
    const form: any = this.$refs.formData
    form.validate((valid: boolean) => {
      if (valid) {
        this.submitData()
        return true
      } else {
        return false
      }
    })
  }

  submitData() {
    const url = '/public/auth/common/login'
    const params = {
      username: sm4Encode(this.formData.phone),
      password: FuncUtils.rsaEncode(this.formData.password),
      code: this.formData.code,
      platformIndex: 1
    }
    this.getTimeDiff()
    JavaHttp.postDataCallback(url, params, (ret: boolean, data: any) => {
      console.log(ret, data)
      if (data.code === 0) {
        const info = Base64.decode(data.data.token).split(':')
        this.user = {
          id: info[0],
          account: this.formData.phone,
          token: data.data.token
        }
        // console.log(Base64.decode(data.data.token), this.user)
        UserModule.saveUserInfo(this.user)
        this.getUserInfo(this.user.token)
      } else if (data.code == 8888) {
        // 修改密码
        this.dlgInfo.formName = 'changePassword'
        this.dlgInfo.width = '400px'
        this.dlgInfo.title = '修改密码'
        this.dlgInfo.formData = {
          account: this.formData.phone,
          password: this.formData.password
        }
        this.dlgInfo.show = true
        this.dlgInfo.uiStatus = 0
      } else {
        FuncUtils.hitMessageError(data.msg)
      }
    })
  }

  // 登录前修正时间戳
  getTimeDiff() {
    try {
      JavaHttp.postDataCallback(
        '/public/currentTimeMillis',
        {},
        (ret: boolean, res: any) => {
          if (res.code === 0) {
            const currTime = parseInt((Date.now() / 1000).toString(), 10)
            const serverTime = parseInt((res.data / 1000).toString(), 10)
            console.log('serve', serverTime)
            console.log('curre', currTime)
            localStorage.setItem('server-time-diff', `${serverTime - currTime}`)
          } else {
            localStorage.setItem('server-time-diff', `${0}`)
          }
        }
      )
    } catch (e) {
      console.log(e)
    }
  }

  getUserInfo(token: string) {
    const url = '/user/getInfo'
    JavaHttp.getData(url).then((ret: any) => {
      if (ret.code === 0) {
        let levelId = 1
        if (ret.data.user.levelId) {
          levelId = ret.data.user.levelId
        }
        localStorage.setItem('belongCode', ret.data.user.belongCode)
        const user = {
          id: ret.data.user.id,
          account: ret.data.user.userName,
          phone: ret.data.user.mobilePhone,
          name: ret.data.user.nickName,
          token: token,
          loginPlate: '管理后台',
          avatar: ret.data.user.avatar,
          desensitizeFlag: ret.data.user.desensitizeFlag,
          // provinceCode: ret.data.user.provinceCode,
          // cityCode: ret.data.user.cityCode,
          // countyCode: ret.data.user.countyCode,
          // streetCode: ret.data.user.streetCode,
          roleId: ret.data.user.roles[0].roleId,
          levelId: levelId,
          roles: ret.data.roles,
          permissions: ret.data.permissions
        }
        UserModule.saveUserInfo(user)
        CookiesUtils.setPermissions(user)
        this.getMenuRouter()
        console.log('saveUserInfo finish', UserModule)
      } else {
        FuncUtils.hitMessageError(ret.msg)
      }
    })
  }

  getMenuRouter() {
    JavaHttp.getData('/menu/getRouters', {}).then((accessRoutes: any) => {
      // 根据roles权限生成可访问的路由表
      CookiesUtils.setRoles(accessRoutes.data)
      location.reload()
    })
  }

  // 忘记密码
  openForgetDlg() {
    this.dlgInfo.formName = 'forgetPassword'
    this.dlgInfo.width = '380px'
    this.dlgInfo.title = '忘记密码'
    this.dlgInfo.formData = {}
    this.dlgInfo.show = true
    this.dlgInfo.uiStatus = 0
  }

  // 现实绑定弹窗
  showBindDlg() {
    const bindAccout = this.$refs.bindAccout as any
    bindAccout.show()
  }

  cancelDlg() {
    this.dlgInfo.show = false
    setTimeout(() => {
      this.dlgInfo.formData = {}
      this.dlgInfo.formName = ''
    }, 200)
  }

  submitDlg(ret: any) {
    if (ret) {
      this.formData.code = ''
    }
    this.cancelDlg()
  }

  getCode() {
    const form: any = this.$refs.formData
    form.validateField('phone', (msg: any) => {
      if (msg) {
        return
      }
      this.getCodeStatus = true
      const params = {
        phone: sm4Encode(this.formData.phone)
      }
      JavaHttp.postData('/public/auth/manageLoginCodeSend', params)
        .then((res: any) => {
          if (res.code == 0) {
            FuncUtils.hitMessageSuccess(res.msg)
            this.btnContent = '重新获取(60秒)'
            let waitSecond = 60
            const timeId = setInterval(() => {
              waitSecond--
              if (waitSecond == 0) {
                this.btnContent = '获取验证码'
                this.getCodeStatus = false
                clearInterval(timeId)
                return
              }
              this.btnContent = '重新获取(' + waitSecond + '秒)'
            }, 1000)
          } else {
            this.btnContent = '获取验证码'
            this.getCodeStatus = false
            if (res.code == 8888) {
              // 修改密码
              this.dlgInfo.formName = 'changePassword'
              this.dlgInfo.width = '330px'
              this.dlgInfo.title = '修改密码'
              this.dlgInfo.formData = {
                account: this.formData.phone,
              }
              this.dlgInfo.show = true
              this.dlgInfo.uiStatus = 0
            } else {
              FuncUtils.hitMessageError(res.msg)
            }
          }
        })
        .catch((error) => {
          this.getCodeStatus = false
        })
    })
  }
}
